// extracted by mini-css-extract-plugin
module.exports = {"con":"intro_con__1UB-5","lef":"intro_lef__1qc0E","rig":"intro_rig__2aQUf"};